import { wrapMethodsWithLogging } from "../../../components/helpers/ErrorHandlingHelpers";
import BaseApiRepository from "../../../repositories/api/BaseApiRepository";

const WorkTimeRegistryApiRepository = {

    async getRecentAsync() {
        return await BaseApiRepository.getAsync('worktime-registry/previous');
    },

    async setAsync(url, obj) {
        return await BaseApiRepository.postAsync(`worktime-registry/${url}`, obj);
    },

    async startWorkTime(obj, whatIf) {
        return await BaseApiRepository.postAsync(`worktime-registry/start?whatIf=${whatIf}`, obj);
    },

    async stopWorkTime(obj) {
        return await BaseApiRepository.postAsync(`worktime-registry/stop`, obj);
    },

    async deleteWorkTime(id) {
        return await BaseApiRepository.postAsync(`worktime-registry/delete/${id}`);
    },

    async updateWorkTime(obj, id, whatIf) {
        return await BaseApiRepository.postAsync(`worktime-registry/update/${id}?whatIf=${whatIf}`, obj);
    },

    async searchSimulateAsync(query) {
        return await BaseApiRepository.postAsync('worktime-registry/simulate', query);
    },

    async registerWorkTimeDeviation(obj) {
        return await BaseApiRepository.postAsync('worktime-registry/deviation', obj);
    },

    async getWorkTimeActivityTypes() {
        return await BaseApiRepository.getAsync('worktime-registry/activity-types');
    },

    async getBreachReasonTypes() {
        return await BaseApiRepository.getAsync('worktime-registry/breach-types');
    },

    async getPilotPilotages() {
        return await BaseApiRepository.getAsync('worktime-registry/pilotages');
    },

    async searchPossibleBreach(query) {
        return await BaseApiRepository.postAsync('worktime-registry/search-breach', query);
    },

    async getWorkTimeActivityTypeSuggestions() {
        return await BaseApiRepository.getAsync('worktime-registry/activity-suggestions');
    },

    async pilotagesInTimeProximity() {
        return await BaseApiRepository.postAsync('worktime-registry/pilotages/proximity');
    },

    async getActivityInfo() {
        return await BaseApiRepository.getAsync('worktime-registry/activity-info');
    },
};
wrapMethodsWithLogging(WorkTimeRegistryApiRepository);

export default WorkTimeRegistryApiRepository;
